window.modalLink;
window.mousedownImage = false;
window.shotLink = false;

import * as customIconJStree from '../../global/jstreeiconstatus';
import * as wexBlog from '../../api/admin/wex';
(function ($) {
    //console.log(wysConf);
    var eTarget = '';
    RVwys.uikitDialog = function (
        header,
        content,
        buttonConfirmLabel,
        onconfirm,
        oncancel
    ) {
        var UI = UIkit;

        if (buttonConfirmLabel == 'Delete') {
            var buttonConfirm =
                '<button class="uk-button uk-button-primary js-modal-confirm">' +
                buttonConfirmLabel +
                '</button>';
        } else {
            var buttonConfirm =
                '<button class="uk-button uk-button-success js-modal-confirm">' +
                buttonConfirmLabel +
                '</button>';
        }

        var options =
            arguments.length > 1 && arguments[arguments.length - 1]
                ? arguments[arguments.length - 1]
                : {};

        var onconfirm = UI.$.isFunction(onconfirm) ? onconfirm : function () {};
        var oncancel = UI.$.isFunction(oncancel) ? oncancel : function () {};
        options = UI.$.extend(
            true,
            {
                bgclose: false,
                keyboard: false,
                modal: false,
                labels: UI.modal.labels,
            },
            UI.$.isFunction(options) ? {} : options
        );

        var modal = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header"><h2>' +
                    header +
                    '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                '<div class="uk-margin uk-modal-content">' +
                    String(content) +
                    '</div>',
                '<div class="uk-modal-footer uk-text-left">' +
                    buttonConfirm +
                    '<button class="uk-button js-modal-confirm-cancel">' +
                    options.labels.Cancel +
                    '</button></div>',
            ].join(''),
            options
        );

        modal.element
            .find('.js-modal-confirm, .js-modal-confirm-cancel')
            .on('click', function () {
                UI.$(this).is('.js-modal-confirm') ? onconfirm() : oncancel();

                //clear cursor
                $('body').css('cursor', 'default');
                //check if not warning modal will hide
                if (!RVwys.warningUiKitDialog) {
                    modal.hide();
                }
            });

        modal.on('show.uk.modal', function () {
            setTimeout(function () {
                // alert( modal.element.html())
                modal.element.find('.tabs').tabs();
                modal.element.find('.js-modal-confirm').focus();
            }, 50);
        });

        return modal.show();
    };

    RVwys.linkUikit = new LinkUikit();

    function LinkUikit() {
        this.openDialogLinkUikit = function () {
            RVwys.linkUikit.getLinkForm = $(
                RVwys.linkUikit.dialogLinkUikit.parent().html()
            );
            RVwys.linkUikit.getLinkForm.dialog({
                open: 'true',
                title: 'Link',
                width: '800',
                height: '550',
                modal: true,
            });

            //build tabs, build file upload
            $('.uikitTabs').each(function () {
                $(this).attr('data-uk-tab', "{connect:'.tab-content'}");

                $('.warningFileSize').hide();
                var tab = UIkit.$(this);
                var obj = UIkit.tab(
                    tab,
                    UIkit.Utils.options(tab.attr('data-uk-tab'))
                );

                var formURL = RVS_AJAX_INDEX;
                formURL = formURL.replace('rvwysiwyguikit', 'sitebuilder');
                console.log('formURL: ' + formURL);

                //build upload form
                var progressbar = $(this)
                    .parents('#linkUikitDialog')
                    .find('#progressbar');
                var bar = progressbar.find('.uk-progress-bar');
                var getFormUpload = $(this)
                    .parents('#linkUikitDialog')
                    .find('#formUploadFileLink');
                var getInputFileUpload = $(this)
                    .parents('#linkUikitDialog')
                    .find('#upload-select')
                    .val();

                var settingsUploadDocument = {
                    action: formURL, // upload url
                    param: 'tmpUpload',
                    params: { rvsMgr: 'RVwysiwyg', rvsAct: 'uploadFile' },
                    before: function (settings, files) {
                        if (files[0].size > 2e6) {
                            $('.warningFileSize')
                                .show()
                                .html(
                                    'File ' +
                                        files[0].name +
                                        ' is ' +
                                        files[0].size +
                                        ' bytes in size'
                                );
                            return false;
                        }

                        $('.listFileDownload')
                            .find('.ulListFileDownload')
                            .empty();
                    },

                    //allow : '*.(jpg|jpeg|gif|png)', // allow only images

                    loadstart: function () {
                        bar.css('width', '0%').text('0%');
                        progressbar.removeClass('uk-hidden');
                    },

                    progress: function (percent) {
                        percent = Math.ceil(percent);
                        bar.css('width', percent + '%').text(percent + '%');
                        if (percent == 99) {
                            progressbar.removeClass('uk-hidden');
                        }
                    },

                    allcomplete: function (response, xhr) {
                        console.log('--> allcomplete');
                        console.log(response);
                        bar.css('width', '100%').text('100%');
                        progressbar.addClass('uk-hidden');
                        $('.warningFileSize').hide();
                        console.log(
                            parent.wex.url.rvsThemImage + 'loading02.gif'
                        );
                        RVwys.linkUikit.ajaxListFile.getData('listDocuments');
                    },
                };

                var select = UIkit.uploadSelect(
                    $(this).parents('#linkUikitDialog').find('#upload-select'),
                    settingsUploadDocument
                );
                var drop = UIkit.uploadDrop(
                    $(this).parents('#linkUikitDialog').find('#upload-drop'),
                    settingsUploadDocument
                );

                //Event for click load list file Document
                $(this)
                    .parents('#linkUikitDialog')
                    .find('a[href=#filesnav]')
                    .click(function () {
                        $('.listFileDownload')
                            .find('.ulListFileDownload')
                            .empty();
                        RVwys.linkUikit.ajaxListFile.getData('listDocuments');
                    });

                //Event for click load list file Image
                $(this)
                    .parents('#linkUikitDialog')
                    .find('a[href=#imagesnav]')
                    .click(function () {
                        $('.listImagesDownload')
                            .find('.ulListImagesDownload')
                            .empty();
                        RVwys.linkUikit.ajaxListFile.getData('listImages');
                    });

                //Event for click load list file Video
                $(this)
                    .parents('#linkUikitDialog')
                    .find('a[href=#medianav]')
                    .click(function () {
                        RVwys.linkUikit.ajaxListFile.getData('listMedia');
                    });
            });

            //list internal page to popup link,internal link
            $('.listLinkPopup').empty();
            $('.listLinkPage').empty();
            console.log('jsonPageStructure :: ' + jsonPageStructure);
            for (var x in jsonPageStructure) {
                $('.listLinkPopup').append(
                    '<div class="linkPopUp"><i class="uk-icon-file-text-o uk-icon-small"></i><span class="titleLinkPopup" gethref="' +
                        jsonPageStructure[x].URL +
                        '">' +
                        jsonPageStructure[x].title +
                        '</span></div>'
                );
                $('.listLinkPage').append(
                    '<div class="linkPage"><i class="uk-icon-file-text-o uk-icon-small"></i><span class="titleLinkPage" gethref="' +
                        jsonPageStructure[x].URL +
                        '">' +
                        jsonPageStructure[x].title +
                        '</span></div>'
                );
            }
            return true;
        };

        this.getSelection = function () {
            if (window.getSelection) {
                var getIframe = document.getElementById('frameBody');
                if (getIframe) {
                    getIframe =
                        getIframe.contentWindow || getIframe.contentDocument;
                    return getIframe.getSelection();
                }
            } else if (
                document.selection &&
                document.selection.createRange &&
                document.selection.type != 'None'
            ) {
                // for ie
                return document.selection.createRange();
            }
        };

        this.handleEventLinkUikit = function () {
            //open Dialog Link
            this.buttonLinkUikit.click(function () {
                RVwys.linkUikit.openDialogLinkUikit();
            });

            //close Dialog Link
            jQuery('body').on('click', '.cancelLink', function () {
                RVwys.linkUikit.getLinkForm.dialog('close');
            });

            //button style Link
            //* jQuery('body').on('click', '.checkButton', function(){
            //     if($(this).attr('checked')){
            //         $(this).parent().find(".sizeButton, .colorButton").removeAttr('disabled');
            //     }else{
            //         $(this).parent().find(".sizeButton, .colorButton").attr('disabled','disabled');
            //     }
            // });

            //choose style button
            //* jQuery('body').on('change', '.styleButton', function(){
            //     switch($(this).val()){
            //         case "pain-text":
            //             $('div.groupbutton').hide();
            //             break;
            //         case "button-style":
            //             $('div.groupbutton').show().find('.ui-link-sample').removeClass('ui-link-sample-round');
            //             break;
            //         case "button-style-round":
            //             $('div.groupbutton').show().find('.ui-link-sample').addClass('ui-link-sample-round');
            //             break;
            //     }
            // });

            //choose color button
            //* jQuery('body').on('click', 'div.colorgroup span.ui-link-button', function(){
            //     RVwys.linkUikit.colorButton = $(this).attr("class").split(" ")[1];
            //     var getOldColorClass = $('div.ui-link-sample').attr("class"),
            //     getOldColorClass = getOldColorClass.match(/uk-button-(\w*)/);

            //     console.log(getOldColorClass);

            //     $('div.ui-link-sample').removeClass("uk-button-"+getOldColorClass[1]).addClass($(this).attr("class").split(" ")[1]);
            // });
        };

        this.addButton = function (elem, isButton, colorButton, sizeButton) {
            if (isButton == 'pain-text') {
                elem.css('color', '');
                return;
            } else if (isButton == 'button-style') {
                // elem.addClass("rv-button "+ colorButton +" "+ sizeButton);
                elem.addClass(colorButton);
            }
            // else if(isButton  == "button-style-round"){
            //     elem.addClass("rv-button rv-button-round "+ colorButton +" "+ sizeButton);
            // }

            // if(colorButton == 'uk-button-yellow' || colorButton == 'uk-button-silver'){
            //     elem.css('color', '#414141');
            // }else{
            //     elem.css('color', 'white');
            // }

            return true;
        };

        this.setEditButton = function (elem) {
            // var isButton = (elem.hasClass("rv-button-round"))? true:false;
            // var round = (isButton)?  round = ' ui-link-sample-round': round = '';
            // var button = (isButton)?  button = 'button-style-round': button = 'button-style';
            // if(elem.hasClass("rv-button")){
            // 	$('.styleButtonPage').last().val(button);
            // 	$('div.groupbutton').show().find('.ui-link-sample').removeClass('uk-button-blue').addClass('uk-button-'+elem.attr("class").match(/uk-button-(\w*)/)[1]+round);
            // }
            // if (elem.attr("class").match(/uk-button-(\w*)/)) {
            // RVwys.linkUikit.colorButton = 'uk-button-'+elem.attr("class").match(/uk-button-(\w*)/)[1];
            // } else {
            // 	RVwys.linkUikit.colorButton = 'uk-button-';
            // }

            if (elem.hasClass('rv-button')) {
                const target = elem.attr('target');
                parent.$('.styleButtonPage').val('button-style');
                parent
                    .$('.targetInternalPage')
                    .val(
                        target === '_self' || target === '_parent'
                            ? '_self'
                            : '_blank'
                    );
                RVwys.linkUikit.colorButton = elem.attr('class');
            }
        };

        this.addTooltips = function (elem, textTooltips, alignmentTooltips) {
            var getAlginmentTooltips = alignmentTooltips || 'top';
            if (!textTooltips) {
                elem.removeAttr('title data-uk-tooltip tooltipholdertext');
                return;
            }
            elem.attr({
                title: textTooltips,
                'data-uk-tooltip': "{pos:'" + getAlginmentTooltips + "'}",
                tooltipholdertext: textTooltips,
            });

            return true;
        };

        this.saveEdit = function (
            elem,
            attrObj,
            thisClassName,
            textTooltips,
            alignmentTooltips,
            isButton,
            colorButton,
            sizeButton
        ) {
            //change attr and class

            attrObj.getHref = encodeURI(attrObj.getHref);
            attrObj.href = encodeURI(attrObj.href);
            attrObj.hrefs = encodeURI(attrObj.href);
            attrObj.holdhref = encodeURI(attrObj.href);

            elem.attr(attrObj)
                .removeAttr('class')
                .addClass('isLinks ' + thisClassName);

            // add tooltips
            RVwys.linkUikit.addTooltips(elem, textTooltips, alignmentTooltips);

            //add button
            RVwys.linkUikit.addButton(elem, isButton, colorButton, sizeButton);
            var fb = $('#frameBody').get(0).contentWindow;
            fb.$('.linkToolEditable').hide();
        };

        this.saveNewLink = function (
            attrObj,
            thisClassName,
            textTooltips,
            alignmentTooltips,
            isButton,
            colorButton,
            sizeButton
        ) {
            var getObj = RVwys.linkUikit.getSelection(),
                newElement,
                getRange,
                colorForButton = 'white';
            var fb = $('#frameBody').get(0).contentWindow;

            getRange = getObj.getRangeAt(0);
            try {
                var aHR = attrObj.href.split('/');
                var name = aHR[aHR.length - 1] || '';
            } catch (e) {
                name = attrObj.href;
            }
            // create tag for wrap
            // newElement= document.createElement("a");
            attrObj.getHref = encodeURI(attrObj.getHref);
            attrObj.href = encodeURI(attrObj.href);

            // add attr for create link page internal
            newElement = $('<a></a>')
                .attr(attrObj)
                .addClass('isLinks ' + thisClassName);
            //newElement= $("<div></div>").attr(attrObj).addClass('isLinks '+thisClassName);
            // add tooltips
            RVwys.linkUikit.addTooltips(
                newElement,
                textTooltips,
                alignmentTooltips
            );

            //add button
            RVwys.linkUikit.addButton(
                newElement,
                isButton,
                colorButton,
                sizeButton
            );

            /*
            // extract to the selected text
            documentFragment = getRange.extractContents();
            // add the contents to the new element
            newElement.appendChild(documentFragment);

            getRange.insertNode(newElement);
            getObj.removeAllRanges();
            */
            if (newElement.html() == '') {
                newElement.html(name);
            }
            var cloneRange = RVwys.getRange();

            $(RVwys.currentIframe).focus();
            if (cloneRange != '') {
                $(newElement).text(cloneRange);
            }
            // alert($(cloneRange.startContainer).get(0).tagName)
            if (mousedownImage) {
                var curImage = $(mousedownImage);
                $(newElement).html(curImage);
                fb.curImage = curImage;
            }
            var outerHTML = $($(newElement).get(0).outerHTML);
            outerHTML.attr('hrefs', outerHTML.attr('href'));
            outerHTML.removeAttr('href');
            // alert(outerHTML.first());
            var id = outerHTML.get(0).id;
            if (id == '') {
                id = new Date().valueOf();

                outerHTML.attr('id', id);
            }
            var edFrame = $(RVwys.currentiFrame);

            RVwys.insertHTML(outerHTML);
            fb.RVwys.currentiFrame = edFrame;
            // alert(fb.$('#'+id).get(0))
            var alink = fb.$('#' + id);
            var rangeOld = RVwys.getRange();
            rangeOld.deleteContents();
            rangeOld.insertNode(outerHTML.get(0));
            var range = document.createRange();
            range.setStart(alink.get(0), alink.get(0).childNodes.length);
            //range.setStart(alink.get(0), 0);
            range.collapse(true);
            getObj.removeAllRanges();
            getObj.addRange(range);
            var css = RVwys.findCssAlink(alink.parent(), {});
            alink.css(css);
            console.log('css');
            console.log(css);
            //fb.$('#'+id).focus();
            setTimeout(function () {
                fb.$('#' + id).focus();
                fb.$('#' + id).trigger('mousedown');
                //fb.$('#'+id).trigger( "mouseup" )
            }, 250);
            //remove parent has tool tips
            if (newElement.parents('.isLinks').eq(0).prop('tagName') == 'A') {
                newElement.parents('.isLinks').eq(0).children().unwrap();
            }

            //remove all span tooptip empty
            newElement.parents('body').find('.isLinks:empty').remove();

            //remove span tooltip in child node
            newElement.find('.isLinks').contents().unwrap();

            fb.$('.linkToolEditable').hide();
        };

        return true;
    }

    RVwys.linkUikit.downloadFile = (function () {
        return {
            getFileDownload: false,
            event: function () {
                jQuery('body').on('click', '.iconFile', function () {
                    $('.ulListFileDownload')
                        .find('div')
                        .css({ 'background-color': '', color: '#333' });
                    $(this)
                        .find('div')
                        .css({ 'background-color': '#cce8ff', color: '#333' });
                    RVwys.linkUikit.downloadFile.getFileDownload =
                        parent.wex.url.STORAGE_URL +
                        '/documents/' +
                        $(this).attr('filename');
                    $('.warningLinkToDownload').last().hide();
                });

                jQuery('body').on('click', '.insertDownloadFile', function () {
                    var getParent = $(this).closest('#linkUikitDialog');
                    var getTextTooltips = getParent
                        .find('.textDownloadFileTooltips')
                        .val();
                    var getAlignmentTooltips = getParent
                        .find('.alignmentDownloadFileTooltips')
                        .val();
                    //var getTargetLink = getParent.find('.targetInternalPage').val();
                    var getIsButton = getParent
                        .find('.checkButtonDownloadFile')
                        .prop('checked');
                    var getColorButton = getParent
                        .find('.colorButtonDownloadFile')
                        .val();
                    var getSizeButton = getParent
                        .find('.sizeButtonDownloadFile')
                        .val();

                    RVwys.linkUikit.downloadFile.insert(
                        getTextTooltips,
                        getAlignmentTooltips,
                        getIsButton,
                        getColorButton,
                        getSizeButton
                    );
                });

                //open dialog link to download file
                jQuery('.lilinkfiles').click(function () {
                    //tooltip upload document type
                    if (parent.wex.documents.documentFileType) {
                        var getAllowFileTypeFile = parent.wex.documents.documentFileType
                            .split(',')
                            .map(function (val, index, arr) {
                                return val.trim().replace(/^\./gi, '');
                            })
                            .join(', .');
                        getAllowFileTypeFile =
                            parent.wex.documents.msgAllowDocumentType +
                            ' ' +
                            getAllowFileTypeFile;
                    } else {
                        var getAllowFileTypeFile =
                            parent.wex.documents.msgAllowDocumentType + ' *.*';
                    }
                    $('#allowDocumentTypeConf').html(getAllowFileTypeFile);

                    RVwys.linkUikit.downloadFile.open();
                });

                //click for delete file
                jQuery('body').on('click', '.deleteFileDocuments', function () {
                    var FileDownload = RVwys.linkUikit.downloadFile
                        .getFileDownload
                        ? true
                        : false;

                    $('.warningLinkToDownload').last().toggle(!FileDownload);

                    if (FileDownload) {
                        RVwys.linkUikit.downloadFile.eventDeleteFile(
                            RVwys.linkUikit.downloadFile.getFileDownload
                        );
                        RVwys.linkUikit.downloadFile.getFileDownload = '';
                    } else {
                        return false;
                    }
                });
            },
            open: function () {
                //build event upload file
                RVwys.linkUikit.downloadFile.eventUploadFile();

                RVwys.uikitDialog(
                    'Link to file',
                    $('#panalLinkToFile').html(),
                    'OK',
                    function () {
                        //check choose page before insert
                        if (RVwys.linkUikit.downloadFile.getFileDownload) {
                            RVwys.warningUiKitDialog = false;
                            RVwys.linkUikit.downloadFile.insert(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                '',
                                $('.txtEmail').last().val(),
                                $('.txtEmailSubject').last().val(),
                                $('.txtEmailBody').last().val()
                            );
                        } else {
                            RVwys.warningUiKitDialog = true;
                            $('.warningLinkToDownload').last().show();
                        }
                    },
                    function () {
                        RVwys.warningUiKitDialog = false;
                        RVwys.linkUikit.downloadFile.getFileDownload = false;
                    }
                );
            },
            edit: function (elem) {
                //build event upload file
                RVwys.linkUikit.downloadFile.eventUploadFile();

                //get current file and highlight
                setTimeout(function () {
                    RVwys.linkUikit.downloadFile.getFileDownload = elem.attr(
                        'gethref'
                    );
                    $('.textPageTooltips')
                        .last()
                        .val(elem.attr('tooltipholdertext'));

                    //check link is button on open edit
                    RVwys.linkUikit.setEditButton(elem);
                }, 1000);

                RVwys.uikitDialog(
                    'Link to file',
                    $('#panalLinkToFile').html(),
                    'OK',
                    function () {
                        //check choose page before insert
                        if (RVwys.linkUikit.downloadFile.getFileDownload) {
                            RVwys.warningUiKitDialog = false;
                            RVwys.linkUikit.downloadFile.insert(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                ''
                            );
                        } else {
                            RVwys.warningUiKitDialog = true;
                            $('.warningLinkToDownload').last().show();
                        }
                    },
                    function () {
                        RVwys.warningUiKitDialog = false;
                        RVwys.linkUikit.downloadFile.getFileDownload = false;
                    }
                );
            },
            insert: function (
                textTooltips,
                alignmentTooltips,
                isButton,
                colorButton,
                sizeButton
            ) {
                if (!RVwys.linkUikit.downloadFile.getFileDownload) {
                    return false;
                }

                var getObj = RVwys.linkUikit.getSelection(),
                    newElement,
                    getRange;

                getRange = getObj.getRangeAt(0);

                // if this is link change attr
                if (
                    $(getRange.startContainer.parentNode)
                        .closest('.isLinks')
                        .hasClass('isLinks')
                ) {
                    RVwys.linkUikit.saveEdit(
                        $(getRange.startContainer.parentNode).closest(
                            '.isLinks'
                        ),
                        {
                            href: RVwys.linkUikit.downloadFile.getFileDownload,
                            getHref:
                                RVwys.linkUikit.downloadFile.getFileDownload,
                            download: '',
                        },
                        'isDownloadFile',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                } else {
                    RVwys.linkUikit.saveNewLink(
                        {
                            href: RVwys.linkUikit.downloadFile.getFileDownload,
                            getHref:
                                RVwys.linkUikit.downloadFile.getFileDownload,
                            download: '',
                        },
                        'isDownloadFile',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                    RVwys.linkUikit.downloadFile.getFileDownload = false;
                    //RVwys.linkUikit.getLinkForm.dialog("close");
                }
            },
            eventUploadFile: function () {
                //document uikit plugin upload: https://getuikit.com/v2/docs/upload.html
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //* $('div.groupbutton').hide();

                setTimeout(function () {
                    var uploadUrl =
                        parent.wex.route_action.routeCommonUrl +
                        '/uploaddocuments';
                    console.log('uploadUrl: ' + uploadUrl);
                    if (parent.wex.documents.documentFileType) {
                        var getAllowFileTypeFile = parent.wex.documents.documentFileType
                            .split(',')
                            .map(function (val, index, arr) {
                                return val.trim().replace(/^\./gi, '');
                            })
                            .join('|');
                        //ห้ามเปลี่ยน join | นะครับ เดี๋ยว match ไม่เจอ
                        getAllowFileTypeFile =
                            '*.(' + getAllowFileTypeFile + ')';
                    } else {
                        var getAllowFileTypeFile = '*.*';
                    }
                    const CSRF_TOKEN = $('meta[name="csrf-token"]').attr(
                        'content'
                    );
                    //build upload form
                    var progressbar = $('.progressbar2').last(),
                        bar = progressbar.find('.uk-progress-bar'),
                        getFormUpload = $('#formUploadFileLink').last(),
                        settingsUploadDocument = {
                            action: uploadUrl, // upload url
                            type: 'post',
                            params: {
                                _token: CSRF_TOKEN,
                            },
                            before: function (settings, files) {
                                console.log('--> brfore:');
                                var file1 = files;
                                for (var i = 0; i < file1.length; i++) {
                                    console.log(
                                        'Filename: ' +
                                            file1[i].name +
                                            ' Type: ' +
                                            file1[i].type +
                                            ' Size: ' +
                                            file1[i].size +
                                            ' bytes'
                                    );
                                }
                                //default 2MB
                                var maxUpload = parent.wex.phpconf
                                    .maxUploadDocumentFile
                                    ? parent.wex.phpconf.maxUploadDocumentFile
                                    : '2097152';
                                var eText = Math.floor(
                                    Math.log(maxUpload) / Math.log(1024)
                                );
                                var maxUploadSize =
                                    (maxUpload / Math.pow(1024, eText)).toFixed(
                                        2
                                    ) +
                                    ' ' +
                                    ' KMGTP'.charAt(eText) +
                                    'B.';

                                console.log('maxUploadSize: ' + maxUploadSize);

                                if (
                                    files[0].size >
                                    Number(
                                        parent.wex.phpconf.maxUploadDocumentFile
                                    )
                                ) {
                                    UIkit.notify({
                                        message:
                                            rvLang(
                                                'Maximum file upload size is'
                                            ) +
                                            ' ' +
                                            maxUploadSize,
                                        status: 'warning',
                                        timeout: 10000,
                                        pos: 'top-center',
                                    });
                                    return false;
                                }

                                $('.listFileDownload').css({
                                    background:
                                        "#FFF url('" +
                                        parent.wex.url.rvsThemImage +
                                        'loading02.gif' +
                                        "') no-repeat center center",
                                });
                                $('.listFileDownload')
                                    .find('.ulListFileDownload')
                                    .empty();
                            },

                            allow: getAllowFileTypeFile, // allow only images

                            loadstart: function () {
                                bar.css('width', '0%').text('0%');
                                progressbar.removeClass('uk-hidden');
                            },

                            progress: function (percent) {
                                percent = Math.ceil(percent);
                                bar.css('width', percent + '%').text(
                                    percent + '%'
                                );
                                if (percent == 99) {
                                    progressbar.removeClass('uk-hidden');
                                }
                            },

                            allcomplete: function (response, xhr) {
                                var data = JSON.parse(response);

                                //mode cpanel
                                console.log('mode cpanel');
                                //console.log(response);
                                bar.css('width', '100%').text('100%');
                                progressbar.addClass('uk-hidden');

                                $('.warningFileSize').hide();
                                console.log(
                                    parent.wex.url.rvsThemImage +
                                        'loading02.gif'
                                );

                                //list file documents
                                if (data.success) {
                                    console.pop.success({ text: data.msg });
                                } else {
                                    console.pop.error({ text: data.msg });
                                }
                                RVwys.linkUikit.ajaxListFile.getData(
                                    'listDocuments'
                                );
                                $('body').css('cursor', 'default');
                            },
                        };

                    $('.upload-select2').css('color', 'transparent');

                    var select = UIkit.uploadSelect(
                        $('.upload-select2').last(),
                        settingsUploadDocument
                    );
                    var drop = UIkit.uploadDrop(
                        $('.upload-drop2').last(),
                        settingsUploadDocument
                    );

                    //clear mouse cursor to default
                    $('body').css('cursor', 'default');
                }, 1000);

                $('.listFileDownload').css({
                    background:
                        "#FFF url('" +
                        parent.wex.url.rvsThemImage +
                        'loading02.gif' +
                        "') no-repeat center center",
                });
                $('.listFileDownload').find('.ulListFileDownload').empty();
                RVwys.linkUikit.ajaxListFile.getData('listDocuments');
            },
            eventDeleteFile: function (deleteFileName) {
                $('.listFileDownload').css({
                    background:
                        "#FFF url('" +
                        parent.wex.url.rvsThemImage +
                        'loading02.gif' +
                        "') no-repeat center center",
                });
                $('.listFileDownload').find('.ulListFileDownload').empty();

                var frmParam = '';
                frmParam += '&fileDeleteName=' + deleteFileName;
                const DELETEURL =
                    parent.wex.route_action.routeCommonUrl + '/deletedocuments';

                console.log('delete url: ' + DELETEURL);
                console.log('frmParam: ' + frmParam);

                $.ajax({
                    type: 'post',
                    url: DELETEURL,
                    data: frmParam,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                            'content'
                        ),
                    },
                    success: function (data) {
                        //list file documents
                        RVwys.linkUikit.ajaxListFile.getData('listDocuments');
                        $('body').css('cursor', 'default');
                    },
                });
            },
        };
    })();
    RVwys.linkUikit.page = (function () {
        return {
            getInternalPage: false,
            isButton: false,
            event: function () {
                jQuery('body').on('click', '.titleLinkPage', function () {
                    $('.titleLinkPage').css({
                        'background-color': '',
                        color: '#333',
                    });
                    $(this).css({
                        'background-color': '#cce8ff',
                        color: '#333',
                    });
                    RVwys.linkUikit.page.getInternalPage = $(this).attr(
                        'getHref'
                    );
                    $('.warningLinkToPage').last().hide();
                });

                jQuery('body').on('click', '.insertPageInternal', function () {
                    var getParent = $(this).closest('#linkUikitDialog');
                    var getTextTooltips = getParent
                        .find('.textPageTooltips')
                        .val();
                    var getAlignmentTooltips = getParent
                        .find('.alignmentPageTooltips')
                        .val();
                    var getTargetLink = getParent
                        .find('.targetInternalPage')
                        .val();
                    var getIsButton = getParent
                        .find('.checkButtonPage')
                        .prop('checked');
                    var getColorButton = getParent
                        .find('.colorButtonPage')
                        .val();
                    var getSizeButton = getParent.find('.sizeButtonPage').val();

                    RVwys.linkUikit.page.insert(
                        getTextTooltips,
                        getAlignmentTooltips,
                        getTargetLink,
                        getIsButton,
                        getColorButton,
                        getSizeButton
                    );
                });

                //open dailog link to internal page
                jQuery('.lilinkpage').click(function () {
                    RVwys.linkUikit.page.open();
                });
            },
            open: function () {
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //                $('.listLinkPage').empty();
                //* $('div.groupbutton').hide();

                RVwys.uikitDialog(
                    'Link to page',
                    $('#panalLinkToPage').html(),
                    'OK',
                    function () {
                        //check choose page before insert

                        if (RVwys.linkUikit.page.getInternalPage) {
                            RVwys.warningUiKitDialog = false;
                            RVwys.linkUikit.page.insert(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.targetInternalPage').last().val(),
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                ''
                            );
                        } else {
                            RVwys.warningUiKitDialog = true;
                            $('.warningLinkToPage').last().show();
                        }
                    },
                    function () {
                        RVwys.warningUiKitDialog = false;
                        RVwys.linkUikit.page.getInternalPage = false;
                    }
                );
                RVwys.linkUikit.loadInternalPage();
            },
            edit: function (elem) {
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                RVwys.linkUikit.page.getInternalPage = elem.attr('getHref');
                window.modalLink = elem;
                // $('div.groupbutton').hide();

                for (var x in jsonPageStructure) {
                    if (!jsonPageStructure[x].URL) {
                        continue;
                    }
                    $('.listLinkPage').append(
                        '<div class="linkPage"><i class="uk-icon-file-text-o uk-icon-small"></i><span class="titleLinkPage" gethref="' +
                            jsonPageStructure[x].URL +
                            '">' +
                            jsonPageStructure[x].title +
                            '</span></div>'
                    );
                }

                setTimeout(function () {
                    $('.listLinkPage')
                        .find('[gethref="' + elem.attr('getHref') + '"]')
                        .css({
                            'background-color': 'transparent',
                            color: '#333',
                        });
                    RVwys.linkUikit.page.getInternalPage = elem.attr('getHref');
                    $('.targetInternalPage').last().val(elem.attr('target'));
                    $('.textPageTooltips')
                        .last()
                        .val(elem.attr('tooltipholdertext'));

                    //check link is button on open edit
                    RVwys.linkUikit.setEditButton(elem);
                }, 100);

                RVwys.uikitDialog(
                    'Link to page',
                    $('#panalLinkToPage').html(),
                    'OK',
                    function () {
                        //check choose page before insert
                        if (RVwys.linkUikit.page.getInternalPage) {
                            RVwys.linkUikit.page.insert(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.targetInternalPage').last().val(),
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                ''
                            );
                            RVwys.warningUiKitDialog = false;
                        } else {
                            RVwys.warningUiKitDialog = true;
                            $('.warningLinkToPage').show();
                        }
                    },
                    function () {
                        RVwys.warningUiKitDialog = false;
                        RVwys.linkUikit.page.getInternalPage = false;
                    }
                );
                RVwys.linkUikit.loadInternalPage();
            },
            insert: function (
                textTooltips,
                alignmentTooltips,
                targetLink,
                isButton,
                colorButton,
                sizeButton
            ) {
                if (!RVwys.linkUikit.page.getInternalPage) {
                    return false;
                }

                var getObj = RVwys.linkUikit.getSelection(),
                    newElement,
                    getRange;

                getRange = getObj.getRangeAt(0);

                console.log(
                    'insert link page ' +
                        $(getRange.startContainer.parentNode)
                            .closest('.isLinks')
                            .hasClass('isLinks')
                );

                // if this is link change attr

                var editorHref = RVwys.linkUikit.page.getInternalPage;
                var pGetHref =
                    parent.wex.url.baseUrl +
                    RVwys.linkUikit.page.getInternalPage.replace(
                        parent.wex.url.WYS_SHOW_URL,
                        ''
                    );
                if (
                    $(getRange.startContainer.parentNode)
                        .closest('.isLinks')
                        .hasClass('isLinks')
                ) {
                    RVwys.linkUikit.saveEdit(
                        $(getRange.startContainer.parentNode).closest(
                            '.isLinks'
                        ),
                        {
                            href: editorHref,
                            getHref: pGetHref,
                            target: targetLink,
                        },
                        'isInternalPage',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                } else {
                    RVwys.linkUikit.saveNewLink(
                        {
                            id: new Date().valueOf(),
                            href: editorHref,
                            getHref: pGetHref,
                            target: targetLink,
                        },
                        'isInternalPage',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                    RVwys.linkUikit.page.getInternalPage = false;
                    RVwys.linkUikit.page.isButton = false;
                    // RVwys.linkUikit.colorButton = "uk-button-blue";
                    //RVwys.linkUikit.getLinkForm.dialog("close");
                }
            },
        };
    })();

    function RVwyslinkPage(ele, Data) {
        $.each(Data, function (k, data) {
            if (
                data.page_id != null ||
                data.page_id != undefined ||
                data.type == 'systempage'
            ) {
                Data[k]['li_attr'] = {
                    class: 'linkPage ',
                    'link-slug-name': data.slug_name,
                };

                Data[k]['a_attr'] = {
                    class: 'titleLinkPage',
                    gethref: parent.wex.url.WYS_SHOW_URL + '/' + data.slug_name,
                };
            }
        });

        ele.jstree({
            core: {
                data: Data,
                check_callback: true,
            },
            types: {
                ...customIconJStree.JStreeTypeIconPage(),
                ...customIconJStree.JStreeTypeIconHome(),
                ...customIconJStree.JStreeTypeIconSystem(),
            },
            search: {
                case_insensitive: true,
                show_only_matches: true,
                search_leaves_only: false,
                show_only_matches_children: false,
            },
            plugins: ['types', 'search'],
        })
            .on('ready.jstree', function (e) {
                if (RVwys.linkUikit.page.getInternalPage) {
                    var url = new RegExp(parent.wex.url.baseUrl + '/(.*)');
                    var isname = RVwys.linkUikit.page.getInternalPage.match(
                        url
                    )[1];
                    var name = isname.match(
                        /admin\/wysiwyg\/uikit\/show\/(.*)/
                    );
                    name = name == null ? isname : name[1];
                    var elm = $(
                        '.uk-modal-dialog li[link-slug-name ="' + name + '"]'
                    );
                    var oID = elm.attr('id');

                    if (elm.length > 0) {
                        var active = $(
                            '.uk-modal-dialog li[link-slug-name ="' +
                                name +
                                '"]'
                        )
                            .closest('div')
                            .attr('class')
                            .match(/^listLink(Page|System|Blog)/);

                        if (active[0] == 'listLinkBlog') {
                            $('.tabs').tabs({
                                active: 1,
                            });
                        } else if (active[0] == 'listLinkSystem') {
                            $('.tabs').tabs({
                                active: 2,
                            });
                        } else {
                            $('.tabs').tabs({
                                active: 0,
                            });
                        }

                        $(
                            '.uk-modal-dialog li[link-slug-name ="' +
                                name +
                                '"] a'
                        )
                            .first()
                            .trigger('click');
                    }
                }
            })
            .on('loaded.jstree', function () {
                $(this).jstree('open_all');
            });
    }

    function RVwyslinkBlog(ele, Data) {
        $.each(Data, function (k, data) {
            Data[k]['a_attr'] = {
                class: 'titleLinkPage',
                gethref: `${parent.wex.url.WYS_SHOW_URL}/${data.slug_prefix}/${data.slug_name}`,
            };
            Data[k]['li_attr'] = {
                class: 'linkPage ',
                'link-slug-name': data.slug_prefix + '/' + data.slug_name,
            };
        });

        ele.jstree({
            core: {
                data: Data,
                check_callback: true,
            },
            types: {
                ...customIconJStree.JStreeTypeIconBlog(),
            },
            search: {
                case_insensitive: true,
                show_only_matches: true,
                search_leaves_only: false,
                show_only_matches_children: false,
            },
            plugins: ['types', 'search'],
        }).on('loaded.jstree', function () {
            $(this).jstree('open_all');
        });
    }

    RVwys.linkUikit.loadInternalPage = async function () {
        var jsonPageData = parent.wex.page.page_tree;
        const blogList = await wexBlog.wexBlogList();
        const blogCategoryList = await wexBlog.wexBlogCategoryList();
        var jsonListblog = [...blogList, ...blogCategoryList];

        var IndexKey = $.map(jsonListblog, function (k, data) {
            return k.id;
        }).indexOf('blogindex9');

        if (IndexKey != -1) {
            jsonListblog.splice(IndexKey, 1);
            $.each(jsonListblog, function (k, v) {
                if (v.type == 'category') {
                    jsonListblog[k].parent = '#';
                }
            });
        }

        var modal = $('.uk-modal-dialog');

        RVwyslinkPage($('.uk-modal-dialog .listLinkPage'), jsonPageData);
        RVwyslinkBlog($('.uk-modal-dialog .listLinkBlog'), jsonListblog);

        var timeout = false;
        modal.find('.linkSearch').keyup(function () {
            var listItem = $(this).val();

            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function () {
                modal.find('.searchHyperlink').jstree('search', listItem);
            }, 250);
        });
    };

    RVwys.linkUikit.bookmark = (function () {
        return {
            storeBookmark: new Array(),
            event: function () {
                jQuery('body').on('click', '.insertBookmark', function () {
                    var getParent = $(this).closest('#linkUikitDialog');
                    var getTextTooltips = getParent
                        .find('.textBookmarkTooltips')
                        .val();
                    var getAlignmentTooltips = getParent
                        .find('.alignmentBookmarkTooltips')
                        .val();
                    var getIsButton = getParent
                        .find('.checkBookmarkButton')
                        .prop('checked');
                    var getColorButton = getParent
                        .find('.colorBookmarkButton')
                        .val();
                    var getSizeButton = getParent
                        .find('.sizeBookmarkButton')
                        .val();
                    var getPositionBookmark = getParent
                        .find('.positionBookmark')
                        .val();
                    var getOperateBookmark = getParent
                        .find('.getbookmark')
                        .prop('checked');
                    var getSetBookmark = getParent
                        .find('.txtSetBookmark')
                        .val();

                    getOperateBookmark
                        ? RVwys.linkUikit.bookmark.insertGet(
                              getTextTooltips,
                              getAlignmentTooltips,
                              getIsButton,
                              getColorButton,
                              getSizeButton,
                              getPositionBookmark
                          )
                        : RVwys.linkUikit.bookmark.insertSet(getSetBookmark);
                });
                jQuery('body').on('click', '.setbookmark', function () {
                    var getParent = $(this).closest('.uk-panel');
                    getParent.find('.containSetBookmark').show();
                    getParent.find('.containGetBookmark').hide();
                });

                jQuery('body').on('keyup', '.txtSetBookmark', function (event) {
                    const thisValue = $(this).val();
                    const isValidateletter =
                        thisValue != ''
                            ? /^[a-zA-Z0-9]+$/.test(thisValue)
                            : true;
                    const elemButtonOK = $(this)
                        .closest('.uk-modal-dialog')
                        .find('.js-modal-confirm');

                    if (!isValidateletter) {
                        elemButtonOK.addClass('disabled disable-ok');
                        console.inline.error({
                            target: $('.containSetBookmark #msgError'),
                            title: Error,
                            text:
                                'Only English characters and numbers are allowed for Bookmark name.',
                        });
                    } else {
                        elemButtonOK.removeClass('disabled disable-ok');

                        $('.containSetBookmark #msgError').html('');
                    }
                });

                jQuery('body').on('click', '.getbookmark', function () {
                    var getParent = $(this).closest('.uk-panel');
                    getParent.find('.containGetBookmark').show();
                    getParent.find('.containSetBookmark').hide();
                });

                jQuery('body').on('click', '.textbookmark', function () {
                    if ($(this).attr('for') == 'getbookmark') {
                        $('.getbookmark').last().prop('checked', true).click();
                        $('.setbookmark').last().prop('checked', false);
                    } else {
                        $('.getbookmark').last().prop('checked', false);
                        $('.setbookmark').last().prop('checked', true).click();
                    }
                });

                //open dailog link to bookmark
                jQuery('.lilinkbookmark').click(function () {
                    RVwys.linkUikit.bookmark.open();

                    $('.getbookmark').last().prop('checked', true).click();
                    $('.setbookmark').last().prop('checked', false);
                });
            },
            open: function () {
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //* $('div.groupbutton').hide();

                RVwys.linkUikit.bookmark.storeBookmark.length = 0;

                $('#frameBody')
                    .contents()
                    .find('.isSetBookmark')
                    .each(function () {
                        RVwys.linkUikit.bookmark.storeBookmark.push(
                            $(this).attr('id')
                        );
                    });

                setTimeout(function () {
                    $('.positionBookmark').last().empty();
                    $('.positionBookmark')
                        .last()
                        .append(
                            '<option value="topmost">' +
                                rvLang('Go to topmost') +
                                '</option>'
                        );
                    /*
                    RVwys.linkUikit.bookmark.storeBookmark.forEach(function(currentValue,index,arr){
                        $('.positionBookmark').last().append('<option value="'+currentValue+'">'+currentValue+'</option>');
                    });
                    */
                    $('#frameBody')
                        .contents()
                        .find('bookmark')
                        .each(function () {
                            //	alert('s'+$(this).get(0).id)
                            $('.positionBookmark')
                                .last()
                                .append(
                                    $(
                                        '<option value="' +
                                            $(this).get(0).id +
                                            '">' +
                                            $(this).get(0).id +
                                            '</option>'
                                    )
                                );
                        });
                }, 500);

                RVwys.uikitDialog(
                    'Link to bookmark',
                    $('#bookmarknav2').html(),
                    'OK',
                    function () {
                        var getOperateBookmark = $('.getbookmark')
                            .last()
                            .prop('checked');

                        console.log(
                            'getOperateBookmark : ',
                            getOperateBookmark
                        );

                        if (getOperateBookmark) {
                            RVwys.linkUikit.bookmark.insertGet(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                '',
                                $('.positionBookmark').last().val()
                            );
                        } else {
                            var str = $('.txtSetBookmark')
                                .last()
                                .val()
                                .replace(
                                    new RegExp('(\\s)|([^a-zA-Z0-9])', 'g'),
                                    ''
                                );
                            //RVwys.linkUikit.bookmark.insertSet(replaceSpaceReferName);
                            RVwys.bookmark.add(str);
                        }
                    }
                );
            },
            edit: function (elem) {
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //* $('div.groupbutton').hide();

                RVwys.linkUikit.bookmark.storeBookmark.length = 0;

                $('#frameBody')
                    .contents()
                    .find('.isSetBookmark')
                    .each(function () {
                        RVwys.linkUikit.bookmark.storeBookmark.push(
                            $(this).attr('id')
                        );
                    });

                setTimeout(function () {
                    $('.positionBookmark').last().empty();
                    $('.positionBookmark')
                        .last()
                        .append(
                            '<option value="topmost">' +
                                rvLang('Go to topmost') +
                                '</option>'
                        );

                    RVwys.linkUikit.bookmark.storeBookmark.forEach(function (
                        currentValue,
                        index,
                        arr
                    ) {
                        $('.positionBookmark')
                            .last()
                            .append(
                                '<option value="' +
                                    currentValue +
                                    '">' +
                                    currentValue +
                                    '</option>'
                            );
                    });

                    $('.textPageTooltips')
                        .last()
                        .val(elem.attr('tooltipholdertext'));
                    //* $('.positionBookmark').last().val(elem.attr('getposition').replace('#',''));
                    if (
                        typeof elem.attr('getposition') !== typeof undefined &&
                        elem.attr('getposition') !== false
                    )
                        $('.positionBookmark')
                            .last()
                            .val(elem.attr('getposition').replace('#', ''));

                    //check link is button on open edit
                    RVwys.linkUikit.setEditButton(elem);
                }, 100);

                RVwys.uikitDialog(
                    'Link to bookmark',
                    $('#bookmarknav2').html(),
                    'OK',
                    function () {
                        var getOperateBookmark = $('.getbookmark')
                            .last()
                            .prop('checked');

                        console.log(
                            'getOperateBookmark : ',
                            getOperateBookmark
                        );

                        if (getOperateBookmark) {
                            RVwys.linkUikit.bookmark.insertGet(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                '',
                                $('.positionBookmark').last().val()
                            );
                        } else {
                            var replaceSpaceReferName = $('.txtSetBookmark')
                                .last()
                                .val()
                                .replace(
                                    new RegExp('(\\s)|([^a-zA-Z0-9])', 'g'),
                                    ''
                                );
                            console.log(
                                'replaceSpaceReferName : ',
                                replaceSpaceReferName
                            );
                            RVwys.linkUikit.bookmark.insertSet(
                                replaceSpaceReferName
                            );
                        }
                    }
                );
            },
            insertGet: function (
                textTooltips,
                alignmentTooltips,
                isButton,
                colorButton,
                sizeButton,
                positionBookmark
            ) {
                var getObj = RVwys.linkUikit.getSelection(),
                    newElement,
                    getRange;

                // getObj = RVwys.getRange();
                getRange = getObj.getRangeAt(0)
                    ? getObj.getRangeAt(0)
                    : RVwys.currentEditor.getSelection().getRangeAt(0);

                // create tag for wrap
                newElement = document.createElement('a');

                // if this is link change attr
                var isLinks = $(getRange.startContainer.parentNode).closest(
                    '.isLinks'
                );

                var findTagLink = $(getRange.startContainer).find('a').get(0)
                    ? $(getRange.startContainer).find('a')
                    : $(getRange.startContainer.parentNode).closest('.isLinks');

                var classNewLink = findTagLink.hasClass('widgetButton')
                    ? findTagLink.addClass('isGetBookmark').attr('class')
                    : 'isGetBookmark';

                if (isLinks.hasClass('isLinks')) {
                    RVwys.linkUikit.saveEdit(
                        $(getRange.startContainer.parentNode).closest(
                            '.isLinks'
                        ),
                        {
                            href: '#' + positionBookmark,
                            getPosition: '#' + positionBookmark,
                        },
                        classNewLink,
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                } else {
                    RVwys.linkUikit.saveNewLink(
                        {
                            href: '#' + positionBookmark,
                            getPosition: '#' + positionBookmark,
                        },
                        classNewLink,
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                    RVwys.linkUikit.bookmark.isButton = false;
                    //* RVwys.linkUikit.colorButton = "uk-button-blue";
                    //RVwys.linkUikit.getLinkForm.dialog("close");
                }
            },
            insertSet: function (setTextBookmark) {
                var getObj = RVwys.linkUikit.getSelection(),
                    newElement,
                    getRange;

                getRange = getObj.getRangeAt(0)
                    ? getObj.getRangeAt(0)
                    : RVwys.currentEditor.getSelection().getRangeAt(0);

                // create tag for wrap
                newElement = document.createElement('span');

                // add attr for create bookmark
                $(newElement)
                    .attr({ id: setTextBookmark })
                    .addClass('isLinks isSetBookmark');

                // extract to the selected text
                var documentFragment = getRange.extractContents();

                // add the contents to the new element
                newElement.appendChild(documentFragment);

                getRange.insertNode(newElement);
                getObj.removeAllRanges();

                //remove parent has tool tips

                if (
                    $(newElement)
                        .parents('.isSetBookmark')
                        .eq(0)
                        .prop('tagName') == 'SPAN'
                ) {
                    $(newElement)
                        .parents('.isSetBookmark')
                        .eq(0)
                        .children()
                        .unwrap();
                }
                //remove all link empty
                $(newElement).parents('body').find('.isLinks:empty').remove();
                //remove span tooltip in child node
                $(newElement).find('.isLinks').contents().unwrap();

                RVwys.linkUikit.bookmark.isButton = false;
                //* RVwys.linkUikit.colorButton = "uk-button-blue";
                //RVwys.linkUikit.getLinkForm.dialog("close");
            },
        };
    })();

    RVwys.linkUikit.linkToWebsite = (function () {
        return {
            event: function () {
                jQuery('body').on('click', '.linkToWebsite', function () {
                    console.log($(this).attr('class'));
                    var getParent = $(this).closest('#linkUikitDialog');
                    var getWebsiteUrl = getParent.find('.websiteUrl').val();
                    var getTarget = getParent.find('.targetWebsiteUrl').val();

                    var getTextTooltips = getParent
                        .find('.textWebsiteTooltips')
                        .val();
                    var getAlignmentTooltips = getParent
                        .find('.alignmentWebsiteTooltips')
                        .val();
                    var getIsButton = getParent
                        .find('.checkButtonWebiste')
                        .prop('checked');
                    var getColorButton = getParent
                        .find('.colorButtonWebsite')
                        .val();
                    var getSizeButton = getParent
                        .find('.sizeButtonWebsite')
                        .val();

                    RVwys.linkUikit.linkToWebsite.insert(
                        getTextTooltips,
                        getAlignmentTooltips,
                        getIsButton,
                        getColorButton,
                        getSizeButton,
                        getWebsiteUrl,
                        getTarget
                    );
                });

                //open dailog link to website
                jQuery('.lilinkwebsite').click(function () {
                    RVwys.linkUikit.linkToWebsite.open();
                });

                //hide warning onclick
                jQuery('body').on('click', '.txtwebsiteurl', function () {
                    $('.warningLinkToExternal').hide();
                });
            },
            open: function () {
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //* $('div.groupbutton').hide();
                $('.warningLinkToExternal').hide();
                RVwys.uikitDialog(
                    'Link to website',
                    $('#panalLinkToWebsite').html(),
                    'OK',
                    function () {
                        //check choose page before insert

                        if (
                            $('.txtwebsiteurl').last().val() &&
                            $('.txtwebsiteurl').last().get(0).checkValidity()
                        ) {
                            RVwys.warningUiKitDialog = false;

                            RVwys.linkUikit.linkToWebsite.insert(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                '',
                                $('.txtwebsiteurl').last().val(),
                                $('.targetInternalPage').last().val()
                            );
                            RVwys.warningUiKitDialog = false;
                        } else {
                            RVwys.warningUiKitDialog = true;
                            $('.warningLinkToExternal').show();
                        }
                    },
                    function () {
                        RVwys.warningUiKitDialog = false;
                    }
                );
            },
            edit: function (elem) {
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //* $('div.groupbutton').hide();
                setTimeout(function () {
                    $('.txtwebsiteurl').last().val(elem.attr('holdhref'));
                    // $('.txtwebsiteurl').last().val(elem.attr('holdhref') === "javascript:void(0)" ? "": elem.attr('holdhref'));
                    $('.targetInternalPage').last().val(elem.attr('target'));
                    $('.textPageTooltips')
                        .last()
                        .val(elem.attr('tooltipholdertext'));

                    //check link is button on open edit
                    RVwys.linkUikit.setEditButton(elem);
                }, 100);

                RVwys.uikitDialog(
                    'Link to website',
                    $('#panalLinkToWebsite').html(),
                    'OK',
                    function () {
                        //check choose page before insert
                        if (
                            $('.txtwebsiteurl').last().val() &&
                            $('.txtwebsiteurl').last().get(0).checkValidity()
                        ) {
                            RVwys.linkUikit.linkToWebsite.insert(
                                $('.textPageTooltips').last().val(),
                                '',
                                $('.styleButton').last().val(),
                                RVwys.linkUikit.colorButton,
                                '',
                                $('.txtwebsiteurl').last().val(),
                                $('.targetInternalPage').last().val()
                            );
                            RVwys.warningUiKitDialog = false;
                        } else {
                            RVwys.warningUiKitDialog = true;
                            $('.warningLinkToExternal').show();
                        }
                    },
                    function () {
                        RVwys.warningUiKitDialog = false;
                    }
                );
            },
            insert: function (
                textTooltips,
                alignmentTooltips,
                isButton,
                colorButton,
                sizeButton,
                getWebsiteUrl,
                getTarget
            ) {
                var getObj = RVwys.linkUikit.getSelection(),
                    newElement,
                    getRange;

                getRange = getObj.getRangeAt(0);

                // if this is link change attr
                if (
                    $(getRange.startContainer.parentNode)
                        .closest('.isLinks')
                        .hasClass('isLinks')
                ) {
                    RVwys.linkUikit.saveEdit(
                        $(getRange.startContainer.parentNode).closest(
                            '.isLinks'
                        ),
                        {
                            href: getWebsiteUrl,
                            holdhref: getWebsiteUrl,
                            target: getTarget,
                        },
                        'isWebsite',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                } else {
                    RVwys.linkUikit.saveNewLink(
                        {
                            href: getWebsiteUrl,
                            holdhref: getWebsiteUrl,
                            gethref: getWebsiteUrl,
                            target: getTarget,
                        },
                        'isWebsite',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );

                    RVwys.linkUikit.page.isButton = false;
                    //* RVwys.linkUikit.colorButton = "uk-button-blue";
                    //RVwys.linkUikit.getLinkForm.dialog("close");
                }
            },
        };
    })();

    RVwys.linkUikit.email = (function () {
        return {
            event: function () {
                jQuery('body').on('click', '.linkToEmail', function () {
                    var getParent = $(this).closest('#linkUikitDialog');
                    var getMailTo = getParent.find('.mailTo').val();
                    var getMailSubject = getParent.find('.mailSubject').val();
                    var getMailBody = getParent.find('.mailBody').val();

                    var getTextTooltips = getParent
                        .find('.textEmailTooltips')
                        .val();
                    var getAlignmentTooltips = getParent
                        .find('.alignmentEmailTooltips')
                        .val();
                    var getIsButton = getParent
                        .find('.checkButtonEmail')
                        .prop('checked');
                    var getColorButton = getParent
                        .find('.colorButtonEmail')
                        .val();
                    var getSizeButton = getParent
                        .find('.sizeButtonEmail')
                        .val();

                    RVwys.linkUikit.email.insert(
                        getTextTooltips,
                        getAlignmentTooltips,
                        getIsButton,
                        getColorButton,
                        getSizeButton,
                        getMailTo,
                        getMailSubject,
                        getMailBody
                    );
                });

                //open dailog link to email
                jQuery('.lilinkmail').click(function () {
                    RVwys.linkUikit.email.open();
                });
            },
            open: function () {
                setTimeout(function () {
                    $('.tabsLinktoEmail').tabs({
                        active: 0,
                    });
                }, 100);
                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //* $('div.groupbutton').hide();

                RVwys.uikitDialog(
                    'Link to email',
                    $('#emailnav2').html(),
                    'OK',
                    function () {
                        RVwys.linkUikit.email.insert(
                            $('.textPageTooltips').last().val(),
                            '',
                            $('.styleButton').last().val(),
                            RVwys.linkUikit.colorButton,
                            '',
                            $('.txtEmail').last().val(),
                            $('.txtEmailSubject').last().val(),
                            $('.txtEmailBody').last().val(),
                            $('.targetInternalPage').last().val()
                        );
                    }
                );
            },
            edit: function (elem) {
                setTimeout(function () {
                    $('.tabsLinktoEmail').tabs({
                        active: 0,
                    });
                }, 100);

                //* $('div.ui-link-sample').removeAttr("Class").addClass("ui-link-sample uk-button-blue");
                //* $('div.groupbutton').hide();
                setTimeout(function () {
                    var getDetailEmail = elem
                        .attr('holdhref')
                        .match(/mailto:(.*)\?subject=(.*)&body=(.*)/);

                    if (getDetailEmail !== null) {
                        $('.txtEmail').last().val(getDetailEmail[1]);
                        $('.txtEmailSubject').last().val(getDetailEmail[2]);
                        $('.txtEmailBody').last().val(getDetailEmail[3]);
                        $('.targetInternalPage')
                            .last()
                            .val(elem.attr('target'));
                        $('.textPageTooltips')
                            .last()
                            .val(elem.attr('tooltipholdertext'));
                    }

                    //check link is button on open edit
                    RVwys.linkUikit.setEditButton(elem);
                }, 100);

                RVwys.uikitDialog(
                    'Link to email',
                    $('#emailnav2').html(),
                    'OK',
                    function () {
                        RVwys.linkUikit.email.insert(
                            $('.textPageTooltips').last().val(),
                            '',
                            $('.styleButton').last().val(),
                            RVwys.linkUikit.colorButton,
                            '',
                            $('.txtEmail').last().val(),
                            $('.txtEmailSubject').last().val(),
                            $('.txtEmailBody').last().val(),
                            $('.targetInternalPage').last().val()
                        );
                    }
                );
            },
            insert: function (
                textTooltips,
                alignmentTooltips,
                isButton,
                colorButton,
                sizeButton,
                getMailTo,
                getMailSubject,
                getMailBody,
                getTarget
            ) {
                var getObj = RVwys.linkUikit.getSelection(),
                    newElement,
                    getRange;

                getRange = getObj.getRangeAt(0);

                // create tag for wrap
                newElement = document.createElement('a');

                console.log(
                    $(getRange.startContainer.parentNode)
                        .closest('.isLinks')
                        .hasClass('isLinks')
                );

                // if this is link change attr
                if (
                    $(getRange.startContainer.parentNode)
                        .closest('.isLinks')
                        .hasClass('isLinks')
                ) {
                    RVwys.linkUikit.saveEdit(
                        $(getRange.startContainer.parentNode).closest(
                            '.isLinks'
                        ),
                        {
                            href:
                                'mailto:' +
                                getMailTo +
                                '?subject=' +
                                getMailSubject +
                                '&body=' +
                                getMailBody,
                            holdhref:
                                'mailto:' +
                                getMailTo +
                                '?subject=' +
                                getMailSubject +
                                '&body=' +
                                getMailBody,
                            target: getTarget,
                        },
                        'isEmail',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );
                } else {
                    RVwys.linkUikit.saveNewLink(
                        {
                            href:
                                'mailto:' +
                                getMailTo +
                                '?subject=' +
                                getMailSubject +
                                '&body=' +
                                getMailBody,
                            holdhref:
                                'mailto:' +
                                getMailTo +
                                '?subject=' +
                                getMailSubject +
                                '&body=' +
                                getMailBody,
                            target: getTarget,
                        },
                        'isEmail',
                        textTooltips,
                        alignmentTooltips,
                        isButton,
                        colorButton,
                        sizeButton
                    );

                    //* RVwys.linkUikit.colorButton = "uk-button-blue";
                    //RVwys.linkUikit.getLinkForm.dialog("close");
                }
            },
        };
    })();

    RVwys.linkUikit.popup = (function () {
        return {
            getInternalPage: false,
            event: function () {
                jQuery('body').on('click', '.titleLinkPopup', function () {
                    $('.titleLinkPopup').css({
                        'background-color': '',
                        color: '#333',
                    });
                    $(this).css({
                        'background-color': '#cce8ff',
                        color: '#333',
                    });
                    RVwys.linkUikit.popup.getInternalPage = $(this).attr(
                        'getHref'
                    );
                });

                jQuery('body').on('click', '.insertPopup', function () {
                    var getParent = $(this).closest('#linkUikitDialog');
                    var getTextTooltips = getParent
                        .find('.textPopopTooltips')
                        .val();
                    var getAlignmentTooltips = getParent
                        .find('.alignmentPopupTooltips')
                        .val();
                    var getIsButton = getParent
                        .find('.checkButtonPopup')
                        .prop('checked');
                    var getColorButton = getParent
                        .find('.colorButtonPopup')
                        .val();
                    var getSizeButton = getParent
                        .find('.sizeButtonPopup')
                        .val();

                    RVwys.linkUikit.popup.insert(
                        getTextTooltips,
                        getAlignmentTooltips,
                        getColorButton,
                        getSizeButton
                    );
                });
            },
            insert: function (
                textPopopTooltips,
                alignmentTooltips,
                colorButton,
                sizeButton
            ) {
                var makeId = new Date().getTime().toString(36);

                if (!RVwys.linkUikit.popup.getInternalPage) {
                    return false;
                }

                var getObj = RVwys.linkUikit.getSelection(),
                    newElement,
                    getRange;

                getRange = getObj.getRangeAt(0);

                // create tag for wrap
                newElement = document.createElement('a');

                // add attr for create popup
                $(newElement)
                    .attr({
                        href: '#' + makeId,
                        'data-uk-modal': '',
                        modalid: makeId,
                        getHref: RVwys.linkUikit.popup.getInternalPage,
                    })
                    .addClass('isLinks isPopup');

                // add tooltips
                RVwys.linkUikit.addTooltips(
                    $(newElement),
                    textPopopTooltips,
                    alignmentTooltips
                );

                //add button
                RVwys.linkUikit.addButton(
                    $(newElement),
                    RVwys.linkUikit.popup.isButton,
                    colorButton,
                    sizeButton
                );

                // extract to the selected text
                var documentFragment = getRange.extractContents();

                // add the contents to the new element
                newElement.appendChild(documentFragment);

                getRange.insertNode(newElement);
                getObj.removeAllRanges();

                //remove parent has tool tips
                if (
                    $(newElement).parents('.isLinks').eq(0).prop('tagName') ==
                    'A'
                ) {
                    $(newElement).parents('.isLinks').eq(0).children().unwrap();
                }

                //remove all span tooptip empty
                $(newElement).parents('body').find('.isLinks:empty').remove();

                //remove span tooltip in child node
                $(newElement).find('.isLinks').contents().unwrap();

                RVwys.linkUikit.popup.getInternalPage = false;
                RVwys.linkUikit.popup.isButton = false;
                RVwys.linkUikit.getLinkForm.dialog('close');
            },
        };
    })();

    RVwys.linkUikit.ajaxListFile = (function () {
        function getDataListFile(getAction, type, filename) {
            var listDocumentUrl =
                parent.wex.route_action.routeCommonUrl + '/listdocuments';
            console.log('listDocumentUrl: ' + listDocumentUrl);
            $.ajax({
                url: listDocumentUrl,
                type: 'get',
                success: function (response) {
                    console.log(response);
                    switch (getAction) {
                        case 'listDocuments':
                            listFileDoucment(response, type, filename);
                            break;
                        case 'listImages':
                            listFileImages(response);
                            break;
                        case 'listMedia':
                            listFileMedia(response);
                            break;
                        default:
                            console.log('Not type list file');
                            break;
                    }
                },
                dataType: 'json',
            });
        }

        function listFileImages(response) {
            var fileDoucument = response.images;
            console.log('listFileImages:');
            console.log(response.images);
            for (var x in fileDoucument) {
                //console.log(fileDoucument[x]);
                switch (x) {
                    case 'dirs':
                        for (var folder in fileDoucument[x]) {
                            if (folder == 0) continue;
                            var getFolderName = fileDoucument[x][folder];
                            getFolderName = getFolderName.split('/');
                            $('.listImagesDownload')
                                .find('.ulListImagesDownload')
                                .append(
                                    '<li class="folderDoucments"><div style="text-align:center;"><i class="uk-icon-folder" style="font-size:300%"></i><div>' +
                                        getFolderName[
                                            getFolderName.length - 1
                                        ] +
                                        '</div></div></li>'
                                );
                        }
                        break;
                    case 'files':
                        for (var fileName in fileDoucument[x]) {
                            var getFileName = fileDoucument[x][fileName];
                            getFileName = getFileName.split('/');
                            $('.listImagesDownload')
                                .find('.ulListImagesDownload')
                                .append(
                                    '<li><div style="text-align:center;"><i class="uk-icon-file" style="font-size:300%"></i><div>' +
                                        getFileName[getFileName.length - 1] +
                                        '</div></div></li>'
                                );
                        }
                        break;
                    default:
                        break;
                }
            }
        }

        function listFileDoucment(response, type, filename) {
            if (response.documents) {
                var fileDoucument = JSON.parse(response.documents);
                for (var x in fileDoucument) {
                    //console.log(fileDoucument[x]);
                    switch (x) {
                        case 'dirs':
                            for (var folder in fileDoucument[x]) {
                                if (folder == 0) continue;
                                var getFolderName = fileDoucument[x][folder];
                                getFolderName = getFolderName.split('/');
                                $('.listFileDownload')
                                    .find('.ulListFileDownload')
                                    .append(
                                        '<li class="folderFile"><div style="text-align:center;"><i class="uk-icon-folder" style="font-size:300%"></i><div>' +
                                            getFolderName[
                                                getFolderName.length - 1
                                            ] +
                                            '</div></div></li>'
                                    );
                            }
                            break;
                        case 'files':
                            for (var fileName in fileDoucument[x]) {
                                var getFileName = fileDoucument[x][fileName],
                                    getFileName = getFileName.split('/'),
                                    getFileName =
                                        getFileName[getFileName.length - 1],
                                    realFileName = fileDoucument[x][
                                        fileName
                                    ].split('/'),
                                    realFileName =
                                        realFileName[realFileName.length - 1];

                                //console.log('filename :: ' + getFileName + ', length :: ' + getFileName.length);
                                if (getFileName.length > 22) {
                                    var splitFilename = getFileName.split('.'),
                                        newFilename = splitFilename[0].substr(
                                            0,
                                            9
                                        );
                                    splitFilename.shift();
                                    getFileName =
                                        newFilename +
                                        '..' +
                                        splitFilename.join('.');
                                    console.log(
                                        'filename :: ' +
                                            getFileName +
                                            ', length :: ' +
                                            getFileName.length
                                    );
                                }
                                $('.listFileDownload')
                                    .find('.ulListFileDownload')
                                    .append(
                                        '<li class="iconFile" filename="' +
                                            realFileName +
                                            '"><div title="' +
                                            realFileName +
                                            '" style="text-align:center;"><i class="uk-icon-file" style="font-size:300%"></i><div>' +
                                            getFileName +
                                            '</div></div></li>'
                                    );
                            }
                            if (type == 'edit') {
                                $('.listFileDownload')
                                    .find('[filename="' + filename + '"] > div')
                                    .css({
                                        'background-color': 'transparent',
                                        color: '#333',
                                    });
                            }
                            break;
                        default:
                            break;
                    }
                }
            }
            $('.listFileDownload').css({ background: '#fff' });
        }

        return {
            getData: getDataListFile,
        };
    })();

    $(document).bind('editorReady', function () {
        RVwys.linkUikit.buttonLinkUikit = $(
            '#buttonLinkUikit,.mini_buttonLinkUikit'
        );
        RVwys.linkUikit.dialogLinkUikit = $('#linkUikitDialog');

        //click edit link
        $('.editLink, #mini_buttonLinkUikit').click(function () {
            var getObj = RVwys.linkUikit.getSelection(),
                newElement,
                getRange;

            getRange = getObj.getRangeAt(0);

            var closestIsLink = $(getRange.startContainer.parentNode).closest(
                '.isLinks'
            );
            var checkIsLink = closestIsLink.hasClass('isLinks');

            if (checkIsLink) {
                RVwys.linkUikit.editLink.checkType(closestIsLink);
            } else {
                RVwys.linkUikit.editLink.checkType(
                    $(getRange.startContainer).closest('.isLinks')
                );
                console.log(
                    '$(getRange.startContainer): ',
                    $(getRange.startContainer)
                );
            }
        });

        //click remove link
        $('.removeLink').click(function () {
            var getObj = RVwys.linkUikit.getSelection(),
                newElement,
                getRange;
            getRange = getObj.getRangeAt(0);

            if (
                $(getRange.startContainer.parentNode)
                    .closest('.isLinks')
                    .hasClass('isLinks')
            ) {
                $(getRange.startContainer.parentNode)
                    .closest('.isLinks')
                    .contents()
                    .unwrap();
            } else {
                $(getRange.startContainer)
                    .closest('.isLinks')
                    .contents()
                    .unwrap();
            }
        });

        RVwys.linkUikit.editLink = (function () {
            return {
                checkType: function (elem) {
                    var getClassName = elem.attr('class');
                    getClassName = getClassName.match(
                        /(isInternalPage|isWebsite|isEmail|isDownloadFile|isGetBookmark)/g
                    );

                    getClassName !== null
                        ? (getClassName = getClassName.toString())
                        : (getClassName = 'false');

                    switch (getClassName) {
                        case 'isInternalPage':
                            RVwys.linkUikit.page.edit(elem);
                            break;
                        case 'isWebsite':
                            RVwys.linkUikit.linkToWebsite.edit(elem);
                            break;
                        case 'isEmail':
                            RVwys.linkUikit.email.edit(elem);
                            break;
                        case 'isDownloadFile':
                            RVwys.linkUikit.downloadFile.edit(elem);
                            break;
                        case 'isGetBookmark':
                            RVwys.linkUikit.bookmark.edit(elem);
                            break;
                        default:
                            if (!elem.is('.widgetButton')) {
                                elem.addClass('isWebsite');
                                const getID = elem.get(0).id;
                                if (getID == '') {
                                    const id = new Date().valueOf();
                                    elem.attr('id', id);
                                }
                                RVwys.linkUikit.linkToWebsite.edit(elem);
                            }

                            break;
                    }
                },
            };
        })();

        $('.toolLink').mouseover(function () {
            try {
                var layInsert = $('.wys-dynamic').position().top + 164;
                var sstop =
                    layInsert > parent.$('#frameBody').height() ? '-135' : '25';
                $('.ddListLink').attr('style', 'top:' + sstop + 'px;');
            } catch (e) {}
        });

        //handle event link dialog
        RVwys.linkUikit.handleEventLinkUikit();
        //handle event popup
        RVwys.linkUikit.popup.event();
        //handle event page
        RVwys.linkUikit.page.event();
        //handle event bookmark
        RVwys.linkUikit.bookmark.event();
        //handel event email
        RVwys.linkUikit.email.event();
        //handel event linktoWebsite
        RVwys.linkUikit.linkToWebsite.event();
        //handel event downloadFile
        RVwys.linkUikit.downloadFile.event();
        RVwys.setShotLink = function (othis, cmd, val) {
            if (cmd == 'text') {
                othis.html(val);
            } else {
                othis.attr(cmd, val);
            }
        };
        $('#shotLinkName,#shotLinkHref').keyup(function () {
            var fb = $('#frameBody').get(0).contentWindow;

            var cmd = $(this).attr('cmd');
            var val = $(this).val();
            console.log('shotLink');
            console.log(fb.shotLink);
            if (fb.shotLink) {
                RVwys.setShotLink(fb.shotLink, cmd, val);
            }
        });
    });
    $(document).bind('designReady', function (e) {
        //alert('sss')
        //tringer editLink

        $('.linkToEdit').click(function (e) {
            parent.$('#mini_buttonLinkUikit').trigger('click');
        });

        $('.linkToRemove').click(function (e) {
            //    		parent.$(".removeLink").trigger( "click" );

            eTarget.contents().unwrap();
            $('.linkToolEditable').hide();
        });
    });

    RVwys.bookmark = {};
    RVwys.bookmark.add = function (str) {
        var bm = $('<bookmark id="' + str + '" class="bookmark"></bookmark>');
        RVwys.insertHTML(bm);
    };

    RVwys.findCssAlink = function (obj, oCSS) {
        //h1~h4,i,b,font
        var tag = obj.get(0).tagName.toLowerCase();
        var h = {};
        //    	h.h1 ={ 'font-size': '2em'};
        //    	h.h2 ={ 'font-size': '1.5em'};
        //    	h.h3 ={ 'font-size': '1.17em'};
        //    	h.h4 ={ 'font-size': '1.12em'};
        //    	h.h5 ={ 'font-size': '.83em'};
        //    	h.h6 ={ 'font-size': '.75em'};
        h.h1 = { 'font-size': '32px' };
        h.h2 = { 'font-size': '24px' };
        h.h3 = { 'font-size': '19px' };
        h.h4 = { 'font-size': '' };
        h.h5 = { 'font-size': '13px' };
        h.h6 = { 'font-size': '11px' };
        switch (tag) {
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                oCSS['font-size'] = h[tag]['font-size'];
                return RVwys.findCssAlink(obj.parent(), oCSS);
            case 'i':
                oCSS['font-style'] = 'italic';
                return RVwys.findCssAlink(obj.parent(), oCSS);
            case 'b':
                oCSS['font-weight'] = 'bolder';
                return RVwys.findCssAlink(obj.parent(), oCSS);
            case 'u':
                if (!oCSS['text-decoration']) {
                    oCSS['text-decoration'] = '';
                }
                oCSS['text-decoration'] += ' underline';
                return RVwys.findCssAlink(obj.parent(), oCSS);
            case 'strike':
                if (!oCSS['text-decoration']) {
                    oCSS['text-decoration'] = '';
                }
                oCSS['text-decoration'] = ' line-through';
                return RVwys.findCssAlink(obj.parent(), oCSS);
            case 'font':
                // code block
                if (obj.attr('color')) {
                    oCSS.color = obj.attr('color');
                }
                if (obj.attr('background-color')) {
                    oCSS['background-color'] = obj.attr('background-color');
                }
                if (obj.attr('face')) {
                    oCSS['font-family'] = obj.attr('face');
                }
                return RVwys.findCssAlink(obj.parent(), oCSS);
            default:
                return oCSS;
        }
        //        settimeout(function(){
        //        	alert('s')
        //        	RVwys.findCssAlink(obj.parent(),oCSS);
        //        },50)
        //        case 'sub':
        //            // code block
        //        	//oCSS +='text-decoration: underline;';
        //             break;
        //        case 'sup':
        //            // code block
        //        	//strCSS +='text-decoration: underline;';
        //             break;
        //             break;
        // code block
    };
    RVwys.activeLinkEditor = function (eTarget) {
        var tag = eTarget.get(0).tagName.toLowerCase();
        //var tagImg = e.target.parentNode.tagName.toLowerCase();
        console.log('link tag : ' + tag);
        if (tag == 'body') {
            $('.linkToolEditable').hide();
            parent.$('.shotLink').hide();
            return false;
        }
        if (tag != 'a') {
            setTimeout(function () {
                RVwys.activeLinkEditor(eTarget.parent());
            }, 10);
            $('.linkToolEditable').hide();
            parent.$('.shotLink').hide();
            return false;
        }

        if (tag == 'a') {
            //        	alert(tag)
            var activeLink = '.addLinkActive';
            var aHref = eTarget.attr('href');
            if (eTarget.attr('hrefs')) {
                var aHref = eTarget.attr('hrefs');
            }

            aHref = decodeURI(aHref);

            if (!eTarget.attr('holdhref')) {
                eTarget.attr('holdhref', aHref);
                if (!eTarget.hasClass('isLinks')) {
                    eTarget.addClass('isLinks');
                }
                //       		 if (!eTarget.hasClass('isWebsite')) {
                //       			 eTarget.addClass('isWebsite');
                //       		 }
            }
            var activeButton = eTarget.hasClass('rv-button');
            $('.linkToolEditable').show();
            $('.linkToolEditable')
                .find('.linkToEdit')
                .show()
                .end()
                .find('.linkToRemove')
                .show()
                .end()
                .find('.buttonToClipboard')
                .toggle(activeButton)
                .end()
                .find('.buttonToEdit')
                .toggle(activeButton)
                .end();

            var rec = new RegExp(
                parent.wex.url.WYS_SHOW_URL + '|javascript:void\\(0\\);?',
                'img'
            );
            if (aHref == '#topmost') {
                aHref = '#';
            }
            var linkName = aHref.replace(rec, '');
            if (linkName == '#') {
                linkName = '#topmost';
            }
            var oLinkk = $('<a href="' + aHref + '">' + linkName + '</a>');
            if (!aHref.match(/^\#/)) {
                oLinkk.attr('target', '_blank');
            }

            $('.linkTo').html(oLinkk);
            var isOffsetLeft = eTarget.offset().left;
            var isOffsetTop = eTarget.offset().top;
            if (eTarget.find('img').get(0)) {
                isOffsetLeft = eTarget.find('img').offset().left;
                isOffsetTop = eTarget.find('img').offset().top;
            }

            $('.linkToolEditable').css({
                left: isOffsetLeft,
                top: isOffsetTop,
            });

            //shotLink
            parent.$('.shotLink').show();
            var isLinkName = eTarget.text() != '' ? true : false;
            parent.$('.shotLinkHTML').toggle(isLinkName);
            parent.$('#shotLinkHTML').html(eTarget.html());
            parent.$('.shotLinkName').toggle(isLinkName);
            parent.$('#shotLinkName').val(eTarget.html());
            parent.$('#shotLinkHref').val(aHref);
            shotLink = eTarget;
        } else {
            var activeLink = '.editLinkActive';
            $('.linkToolEditable').hide();
            parent.$('.shotLink').hide();
            shotLink = false;
        }

        //parent.$('.linkActive').hide();
        //parent.$('.linkActive').not(activeLink).show();
    };
    RVwys.designViewAddEvent('mousedown', function (e) {
        // console.log($(e.target).get(0).tagName)
        // alert($(e.target).get(0).tagName)

        var validBM = { bookmark: true, BOOKMARK: true, undefined: false };
        if (validBM[$(e.target).get(0).tagName]) {
            // alert('s')
        }
        eTarget = $(e.target);
        RVwys.activeLinkEditor($(e.target));
    });

    RVwys.designViewAddEvent('mouseup', function (e) {
        var eTarget = $(e.target).get(0);
        // $(e.target).attr('href',$(e.target).attr('hrefs'))
        // $(e.target).removeAttr('hrefs');
        console.log('ssss->' + eTarget.className);
        parent.mousedownImage =
            eTarget.tagName.toLowerCase() == 'img' ? eTarget.outerHTML : false;
        if ($(e.target).hasAnyClass('borderResize pointBlock')) {
            setTimeout(function () {
                //alert(imageCur.get(0))
                parent.mousedownImage = $(e.target).get(0).outerHTML;
            }, 250);
        }
    });
    RVwys.designViewAddEvent('keydown', function (e) {
        e.target = window.getSelection().anchorNode.parentNode;
        var eTarget = $(e.target);
        RVwys.activeLinkEditor(eTarget);
    });
})(jQuery);
